/* eslint-disable */
import React, { useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { CTitle, STitle } from '../../components/Widget';
import { useUpdateComponentState } from '../../../hooks';
import MisconceptionCards from '../../components/MisconceptionCards';
import PracticeGridCards from '../../components/PracticeGridCards';
import { tpv_ICON_Map } from '../../components/MisconceptionCards/cardIcons';
interface ISection1Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const updateComponentState = useUpdateComponentState();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );

  const handleMisconceptionCardsComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-tpv-section2-1'
    );
  }, [updateComponentState, p_course, p_topic, ID]);

  return (
    <div className="topic-section-2">
      {paragraphsSettings?.l4?.length ? (
        <>
          <CTitle title={paragraphsSettings?.title ?? ''} />
          <div className="sub-title">{paragraphsSettings?.l4Title}</div>
          <PracticeGridCards
            description={paragraphsSettings?.l4SubTitle}
            items={paragraphsSettings?.l4}
            variant="tpv"
          />
        </>
      ) : null}
      <MisconceptionCards
        title={paragraphsSettings?.misconceptionCardsTitle}
        items={paragraphsSettings?.misconceptionCardsList}
        tips={paragraphsSettings?.misconceptionCardsTips}
        icons={tpv_ICON_Map}
        id="student-training-tpv-section2-1"
        onComplete={handleMisconceptionCardsComplete}
      />
    </div>
  );
};

export default Section2;
